import { AppointmentCreationResult } from '@dreryk/egabinet-appointment-frontend-api';
import { AppointmentId } from '@dreryk/egabinet-appointment-published-language-api';

export const getFirstAppointmentId = (result: AppointmentCreationResult | undefined): AppointmentId | null => {
   const [firstAppointmentId] = result?.ids ?? [];
   return firstAppointmentId ?? null;
};
